import React, { useCallback, useMemo } from 'react';
import find from 'lodash/find';
import head from 'lodash/head';
import size from 'lodash/size';
import map from 'lodash/map';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilterFields,
  FetchProductsFilters
} from '../../../../../../../../products/productsTypes';
import { CacheFetchProductsAggregationsQueryResponseAggregations } from '../../../../../../../../products/queries/fetchCacheProductsAggregations.query';

import { Translate } from '../../../../../../../../../helpers/Translate';
import { PureIconButtonHelper } from '../../../../../../../../../helpers/buttons/PureIconButtonHelper';

import { categoriesKeys } from '../../../../../../../../../locales/keys';

import { IconsEnum } from '../../../../../../../../../assets/icons/types';

interface ProductsCollectionsFilterBadgeProps {
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
  productsAggregations: CacheFetchProductsAggregationsQueryResponseAggregations;
}

function ProductsCollectionsFilterBadge({
  changeProductsFilters,
  productsFilters,
  productsAggregations
}: ProductsCollectionsFilterBadgeProps) {
  const collections = useMemo(() => {
    const selectedIds =
      productsFilters[FetchProductsFilterFields.COLLECTION_ID]?.in || [];

    if (!size(selectedIds) || !productsAggregations?.collections) {
      return [];
    }

    return map(selectedIds, (id) =>
      find(productsAggregations.collections, { id })
    );
  }, [productsFilters, productsAggregations]);

  const handleRemoveFilter = useCallback(() => {
    changeProductsFilters({}, [FetchProductsFilterFields.COLLECTION_ID]);
  }, [changeProductsFilters]);

  const valueCount = size(collections);

  if (!valueCount) {
    return null;
  }

  return (
    <div className="relative bg-blue-500 bg-opacity-20 dark:text-gray-200 inline-flex items-center m-0.5 px-3 py-1.5 rounded-md text-gray-800 text-sm ">
      <div>
        <Translate id={categoriesKeys.collections.plural} />: &nbsp;
        {size(collections) === 1 ? head(collections)?.name : valueCount}
      </div>

      <PureIconButtonHelper
        className="flex-shrink-0 ml-1 -my-1 -mr-2 h-6 w-6 rounded inline-flex items-center justify-center text-gray-800 dark:text-gray-200 hover:bg-gray-500 hover:bg-opacity-20 hover:text-gray-700 dark:hover:bg-opacity-20 dark:hover:bg-white dark:hover:text-white"
        dataGa={`${FetchProductsFilterFields.BRAND_ID}-clear`}
        icon={IconsEnum.X}
        iconClassName="h-3.5 w-3.5"
        onClick={handleRemoveFilter}
      />
    </div>
  );
}

export default ProductsCollectionsFilterBadge;
